import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CORE_CONCEPT_DETAILS } from './CoreConceptDetailsContext.js';
import './ConceptDetailPage.css';

function CoreConceptDetails() {
  const { detailKey } = useParams();
  const navigate = useNavigate();

  const conceptKeys = Object.keys(CORE_CONCEPT_DETAILS);
  const currentIndex = conceptKeys.indexOf(detailKey);
  const nextKey = conceptKeys[currentIndex + 1];
  const concept = CORE_CONCEPT_DETAILS[detailKey];

  if (!concept) {
    return (
      <div className="concept-detail-container">
        <h2 className="concept-not-found">Concept Not Found</h2>
        <p>The requested training module does not exist.</p>
      </div>
    );
  }

  return (
    <div className="concept-detail-container">
      <button className="back-to-button" onClick={() => navigate('/console/guides')}>&larr; Back to Guides</button>
      <div className="concept-card">
        <h1 className="concept-detail-title">{concept.title}</h1>
        {concept.image && (
          <img
            loading="lazy"
            src={concept.image}
            alt={`${concept.title} visual`}
            className="concept-image-banner"
          />
        )}
        <hr />
        <div
          className="concept-detail-body"
          dangerouslySetInnerHTML={{ __html: concept.body }}
        />
        <div className="concept-nav-footer">
          <button
            className="concept-back-button"
            onClick={() => {
              window.scrollTo(0, 0); // Scroll to top
              navigate(-1);
            }}
          >
            &larr; Back
          </button>

          {nextKey && (
            <button
              className="concept-next-button"
              onClick={() => {
                window.scrollTo(0, 0); // Scroll to top
                navigate(`/console/sop/${nextKey}`);
              }}
            >
              {CORE_CONCEPT_DETAILS[nextKey].title} &rarr;
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CoreConceptDetails;
